import axios from 'axios';
import moment from 'moment';
import BaseMitConfigService from './BaseMitConfigService.js';
import BaseMitExternalApiService from './BaseMitExternalApiService.js';

class BaseMitKeysApiService {
  constructor() {
    this.service = new BaseMitExternalApiService();
    this.url = BaseMitConfigService.get('CLIENT_API_KEYS');
  }

  adaptSpacesToUIModel(key){
      const spaceName = [];
      for(let x = 0; x < key.spaces.length; x++){
        spaceName.push(key.spaces[x].mitId)
      }

      key.spacesDisplay = spaceName;
  }
  adaptToUIModel(keys){
    for(let x = 0; x < keys.length; x++){
      keys[x].dates_local = {
        checkoutDt: moment(keys[x].checkoutDt).local().fromNow(),
        returnDt: keys[x].returnDt != null ? moment(keys[x].returnDt).local().fromNow() : null
      };
      //create a flat list of names that should NOT be edited, this is just a read only list for display purposes
      this.adaptSpacesToUIModel(keys[x])
    }

    return keys;
  }

  getMyKeys() {
    return new Promise ((resolve, reject) => {
      this.service.getData('GET', this.url,'/keys/user/borrowed/my')
        .then((response) => {
          let borrowedKeys = response.borrowed;

          this.adaptToUIModel(borrowedKeys)

          return resolve(borrowedKeys);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error.response.data);
        });

    });
  }
}

export default BaseMitKeysApiService;
